import { 
  collection, 
  addDoc, 
  query, 
  where, 
  orderBy, 
  onSnapshot,
  serverTimestamp,
  doc,
  setDoc
} from 'firebase/firestore';
import { db } from './config';

// Create or get conversation between two users
export const getConversationId = (userId1, userId2) => {
  return [userId1, userId2].sort().join('_');
};

// Send a message
export const sendMessage = async (senderId, receiverId, text) => {
  const conversationId = getConversationId(senderId, receiverId);
  
  try {
    // Add message to messages subcollection
    await addDoc(collection(db, 'conversations', conversationId, 'messages'), {
      senderId,
      receiverId,
      text,
      timestamp: serverTimestamp(),
      read: false
    });

    // Update conversation metadata
    await setDoc(doc(db, 'conversations', conversationId), {
      participants: [senderId, receiverId],
      lastMessage: text,
      lastMessageTime: serverTimestamp(),
      [`unreadCount.${receiverId}`]: 1 // Increment unread count
    }, { merge: true });

    return { success: true };
  } catch (error) {
    console.error('Error sending message:', error);
    return { success: false, error };
  }
};

// Listen to messages in real-time
export const subscribeToMessages = (userId1, userId2, callback) => {
  const conversationId = getConversationId(userId1, userId2);
  
  const q = query(
    collection(db, 'conversations', conversationId, 'messages'),
    orderBy('timestamp', 'asc')
  );

  return onSnapshot(q, (snapshot) => {
    const messages = [];
    snapshot.forEach((doc) => {
      messages.push({ id: doc.id, ...doc.data() });
    });
    callback(messages);
  });
};

// Get all conversations for a user
export const subscribeToConversations = (userId, callback) => {
  const q = query(
    collection(db, 'conversations'),
    where('participants', 'array-contains', userId),
    orderBy('lastMessageTime', 'desc')
  );

  return onSnapshot(q, (snapshot) => {
    const conversations = [];
    snapshot.forEach((doc) => {
      conversations.push({ id: doc.id, ...doc.data() });
    });
    callback(conversations);
  });
};